import * as types from '../actionTypes/PasswordResetActionTypes';

function PasswordResetReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.PASSWORD_RESET:
            return { ...state, isLoading: true, passwordResetResponse: {} };

        case types.PASSWORD_SET:
            return { ...state, isLoading: true, passwordResetResponse: {} };

        case types.GET_ACCOUNT_EMAIL:
            return { ...state, isLoading: true, passwordResetResponse: {} };

        case types.PASSWORD_RESET_ERROR:
        case types.PASSWORD_RESET_SUCCESS: {
            const passwordResetResponse = action.payload;
            return { ...state, passwordResetResponse, isLoading: false };
        }

        case types.PASSWORD_SET_FAILURE:
        case types.PASSWORD_SET_SUCCESS: {
            const passwordSetResponse = action.payload;
            return { ...state, passwordSetResponse, isLoading: false };
        }

        case types.GET_ACCOUNT_EMAIL_SUCCESS: {
            const accountEmailResponse = action.response;
            return { ...state, accountEmailResponse, isLoading: false };
        }

        case types.GET_ACCOUNT_EMAIL_ERROR: {
            const accountEmailErrorResponse = action.errorResponse;
            return { ...state, accountEmailErrorResponse, isLoading: false };
        }

        case types.RESET_PASSWORD_SLIDER_STATE: {
            return {
                ...state,
                requestOTPDetails: {},
                verifyOTPDetails: {},
                newPasswordDetails: {},
                passwordResetResponse: {},
                resetPasswordSliderState: '',
            };
        }

        case types.POST_REQUEST_OTP_TO_RESET_PASSWORD: {
            const { phoneNumber } = action.payload;
            const requestOTPDetails = {
                ...state.requestOTPDetails,
            };
            const resentSuccess = false;
            const resendEnable = false;
            return {
                ...state,
                verifyOTPDetails: {},
                phoneNumber,
                requestOTPDetails,
                resendEnable,
                resentSuccess,
                isLoading: true,
                passwordResetResponse: {},
            };
        }

        case types.POST_REQUEST_OTP_TO_RESET_PASSWORD_SUCCESS: {
            const requestOTPDetails = {
                ...state.requestOTPDetails,
                success: true,
            };
            const resetPasswordSliderState = 'VERIFY_OTP';

            const { isReSendRequest, phoneNumber, isSignInSliderReq } = action.payload;

            const resentSuccess = isReSendRequest || false;
            const error = {};
            return {
                ...state,
                requestOTPDetails,
                resetPasswordSliderState,
                error,
                phoneNumber,
                resentSuccess,
                isLoading: false,
                isSignInSliderReq,
            };
        }

        case types.POST_REQUEST_OTP_TO_RESET_PASSWORD_ERROR: {
            const requestOTPDetails = {
                ...state.requestOTPDetails,
                success: false,
            };
            const error = action.payload || {};
            return {
                ...state,
                requestOTPDetails,
                passwordResetResponse: { ...error, isSuccess: false },
                isLoading: false,
            };
        }

        case types.VERIFY_OTP_TO_RESET_PASSWORD: {
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                otp: action.payload.otp,
                isLoading: true,
                error: {},
            };
            return { ...state, verifyOTPDetails, error: {} };
        }
        case types.VERIFY_OTP_TO_RESET_PASSWORD_SUCCESS: {
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                isLoading: false,
                success: true,
                error: {},
            };
            const resetPasswordSliderState = 'SET_NEW_PASSWORD';
            return { ...state, verifyOTPDetails, resetPasswordSliderState };
        }
        case types.VERIFY_OTP_TO_RESET_PASSWORD_ERROR: {
            const error = action.payload || {};
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                isLoading: false,
                success: false,
                error,
            };
            return { ...state, verifyOTPDetails };
        }

        case types.SET_NEW_PASSWORD_USING_PHONE_NUMBER: {
            const newPasswordDetails = {
                ...state.newPasswordDetails,
                isLoading: true,
                error: {},
            };
            return { ...state, newPasswordDetails, error: {} };
        }
        case types.SET_NEW_PASSWORD_USING_PHONE_NUMBER_SUCCESS: {
            const newPasswordDetails = {
                ...state.newPasswordDetails,
                isLoading: false,
                success: true,
                error: {},
            };
            return {
                ...state,
                newPasswordDetails,
                resetPasswordSliderState: 'SET_NEW_PASSWORD_SUCCESS',
            };
        }
        case types.SET_NEW_PASSWORD_USING_PHONE_NUMBER_ERROR: {
            const newPasswordDetails = {
                ...state.newPasswordDetails,
                isLoading: false,
                success: false,
                error: action.payload || {},
            };
            return { ...state, newPasswordDetails };
        }

        case types.ENABLE_RESEND_OTP_TO_RESET_PASSWORD: {
            const resendEnable = true;
            return { ...state, resendEnable };
        }

        default:
            return state;
    }
}
PasswordResetReducer.reducerName = 'passwordResetDetails';
export default PasswordResetReducer;
